<app-navbar title="Historia">
	<a routerLink="../history-drivers" class="btn btn-primary me-4"> <i class="fas fa-user"></i> Historia kierowców </a>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<app-history type="tourism_events" [id]="id"></app-history>
